import { PaginationStore } from "@/store/pagination-store";
import RobotService from "../RobotService.js";
import { RobotSessionResponse, SessionData } from "@/models/RobotResponse.js";
import errorManager from "@/modules/errors/error-services/error-manager.js";
// import { ErrorMessage } from "@/models/ErrorMessage.js";
import LabelService from "@/modules/label-group/LabelService.js";
import { String } from "core-js";
import { dateTimeFormat } from "@/utils/time-formatter.js";
import { optionsStore } from "@/store/options.js";

class RobotSessionStore extends PaginationStore {
  data() {
    return {
      imei: "",
      labelList: [],
      sizes: [2, 5, 10, 20, 50, 100],
      reasons: [
        { label: "caster-ready", value: "caster-ready" },
        { label: "caster-terminated", value: "caster-terminated" },
        { label: "session_finished", value: "session_finished" },
        { label: "sources_table_served", value: "sources_table_served" },
        {
          label: "new_ntrip_request_accepted",
          value: "new_ntrip_request_accepted",
        },
      ],
      lastConnection: new SessionData({}),
      logs:[],
      //call that accept pagination as param and return {pagination, data} as response
      call: async (pagination) => {
        console.log("store-call");
        const param = {
          page: pagination.currentPage,
          size: pagination.elements > 0 ? pagination.elements : 10,
        };
        if (pagination.filters) {
          pagination.filters.baseStationName &&
            pagination.filters.baseStationName != ""
            ? (param["baseStationName"] = pagination.filters.baseStationName)
            : null;
          pagination.filters.reasonSessionTerminated &&
            pagination.filters.baseStationName != ""
            ? (param["reasonSessionTerminated"] =
              pagination.filters.reasonSessionTerminated)
            : null;
        }
        if (this.getState().imei && this.getState().imei.length > 0) {
          return this.getRobotHistory(param);
        } else {
          return new Promise(() => []);
        }
      },
    };
  }
  initCall() {
    this.state.call = (pagination) => this.getRobotSessions(pagination);
  }
  loadLabelsByImei() {
      LabelService.getLabelsByImei(this.state.imei).then(({data})=>{
        this.state.labelList=data["accessLabels"];
      }).catch(e=>errorManager.manage(e));
  }

  async getRobotSessions(pagination) {
    console.log("store-call");
    const param = {
      page: pagination.currentPage,
      size: pagination.elements > 0 ? pagination.elements : 10,
    };
    if (this.getState().imei && this.getState().imei.length > 0) {
      return RobotService.getRobotConnections(this.getState().imei, param)
        .then((response) => {
          console.log(response);
          let result = new RobotSessionResponse({});
          if (response.data) {
            result = new RobotSessionResponse(response.data);
          }
          return Promise.resolve(result);
        })
        .catch((error) => {
          return errorManager.manage(
            error,
            errorManager.defaultCase(() => {
              errorManager.pushPageError(error);
              return Promise.reject(error);
            })
          );
        });
    } else {
      return new Promise(() => []);
    }
  }
  async refreshLastConnection() {
    return this.getRobotHistory({
      page: 0,
      size: 1,
    }).then(async (connections) => {
      console.log(connections);
      this.loadLabelsByImei();
      this.state.lastConnection =
        connections.data.length > 0 ? connections.data[0] : new SessionData({});
    })
  }


// if the operation is type UPDATE it means that the system has updated something
// if the operation is type REMOVE it means that the system has removed something
 async loadSystemOperations(){
    try {
      const response = await RobotService.getSystemOperations(this.state.imei);
      this.state.logs=response.data.map((item)=>({logTime: item.timestamp>0?dateTimeFormat(
        item.timestamp/1000,
        optionsStore.getState().locale,
        optionsStore.getState().timezone
      ):0,message:String('the system performed operation: '+item.operation+ ' on element '+ 
         Object.entries(item.elementsInvolved)
        .map(([key, value]) =>key+' with value '+value+'').join(', '))}));
      return Promise.resolve(this.state.logs);
    } catch (error) {
      this.state.logs=[];
      return errorManager.manage(
        error,
        errorManager.caseNotFound(() =>
          Promise.resolve([])
        ),
        errorManager.defaultCase(() => {
          errorManager.pushPageError(error);
          return Promise.reject(error);
        })
      );
    }
    
  }

  async getRobotHistory(param) {
    try {
      const response = await RobotService.getRobotConnections(
        this.getState().imei,
        param
      ).catch((error) => {
        return errorManager.manage(
          error,
          errorManager.caseNotFound(() => {
           console.log("NO Connections Found for imei: "+this.getState().imei);
            return Promise.resolve({ data: { data: [], pagination: {} } });

          })
        );
      });
      console.log(response);
      let result_1 = new RobotSessionResponse({});
      if (response.data) {
        result_1 = new RobotSessionResponse(response.data);
      }
      return await Promise.resolve(result_1);
    } catch (error) {
      console.log(error);
      return await errorManager.manage(
        error,
        errorManager.caseNotFound(() =>
          Promise.resolve(new RobotSessionResponse({}))
        ),
        errorManager.defaultCase(() => {
          errorManager.pushPageError(error);
          return Promise.reject(error);
        })
      );
    }
  }

  setImei(imei) {
    this.state.imei = imei;
  }
}
export const robotSessionStore = new RobotSessionStore("ROBOT_SESSIONS");
